import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ServiceStore } from '../../models/service.model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ServiceStoreService {
  
  private baseUrl = HttpClientService.BASE_MS_COMMON + '/serviceStore/';
  private baseUrlCommon = HttpClientService.BASE_MS_COMMON;
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(id: number): Observable<ServiceStore> {
    //return this.h.get(this.baseUrl + '/serviceStores/' + id)
    return this.h.getPaged(this.baseUrl + '/serviceStores/' + id)
      .map(res => {
        return res;
      });
  }

  getAll(): Observable<ServiceStore[]> {
    return this.h.get(this.baseUrl + '/serviceStores')
      .map(res => {
        return res;
      });
  }

  delete(id: number) {
    return this.h.delete(this.baseUrl + '/serviceStores/' + id)
      .map(res => {
        this.srvNotify.add({severity: 'success', summary: 'Confirmed', detail: 'Service deleted'});
      });
  }

  post(newData: ServiceStore) {
    return this.h.post(this.baseUrl + '/serviceStores/', newData)
      .map(res => {
        newData.id = res.id;
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(data: ServiceStore) {
    return this.h.put(this.baseUrl + '/serviceStores/', data)
      .map(res => {
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
      });
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get(this.baseUrlCommon + '/schema/ServiceStoreDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/service/service-store.service.ts